import React from 'react'
import { DocumentNode } from 'graphql'
import { Query } from 'react-apollo'
import { AggregationOptions } from '../aggregations'
import { CustomApplicationAggregation } from '../applications-grid'

interface ChildProps {
  readonly customMetadataAggregations: CustomApplicationAggregation[]
}

interface Props<TAggregationCategory extends string> {
  readonly query: DocumentNode
  readonly organizationID: string
  readonly aggregationFilters: AggregationOptions<TAggregationCategory>
  readonly additionalFilters?: { readonly [key: string]: any }
  readonly children: (props: ChildProps) => React.ReactNode
}

// TODO flowmap - add tests CONTRAST-37856
export function MetadataAggregationsLoader<
  TAggregationCategory extends string
>({
  query,
  organizationID,
  aggregationFilters,
  additionalFilters,
  children
}: Props<TAggregationCategory>) {
  const variables = Object.assign({}, aggregationFilters, {
    organizationID,
    ...additionalFilters
  })

  return (
    <Query fetchPolicy="network-only" query={query} variables={variables}>
      {({ data }) => {
        const customMetadataAggregations =
          (data && data.customArchitectureAssociatedApplicationAggregations) ||
          []

        return children({
          customMetadataAggregations
        })
      }}
    </Query>
  )
}
